var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticStyle:{"text-align":"left"},attrs:{"no-gutters":""}},[_c('MarkdownViewer',{attrs:{"content":_vm.mdText,"flat":true,"outlined":false,"elevation":0,"transparent":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }